var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeHoliday && _vm.menuButtonComponent && _vm.animationEnabled)?_c(_vm.menuButtonComponent,{tag:"component"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }